import { logError } from "../../utils/logger";

const INACTIVITY_TIMEOUT_MS = process.env.REACT_APP_USER_INACTIVITY_TIME ?? 1800000

export const updateChatInactivityTimer = () => {
    try {
        const currentTime = Date.now();
        localStorage.setItem("chatInactivity", currentTime.toString());
    } catch (error) {
        logError('Error updating chat inactivity timer:', error);
    }
};

export const getChatInactivityTimestamp = () => {
    try {
        const timestamp = localStorage.getItem("chatInactivity");
        return timestamp ? parseInt(timestamp, 10) : null;
    } catch (error) {
        updateChatInactivityTimer()
        logError('Error getting chat inactivity timestamp:', error);
        return null;
    }
};

export const isChatsInactiveMoreThan30Minutes = () => {
    try {
        const timestamp = getChatInactivityTimestamp();
        if (!timestamp) {
            updateChatInactivityTimer();

            return false;
        }

        const currentTime = Date.now();
        const timeDifference = currentTime - timestamp;

        return timeDifference > INACTIVITY_TIMEOUT_MS;
    } catch (error) {
        updateChatInactivityTimer();
        logError('Error checking chat inactivity:', error);
        return false;
    }
};